import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69c2fa377d947e0014d212e0/barbershopschargeact/src/app/apply/page.tsx");
